module.exports = __webpack_public_path__ + "static/media/CV_FrancoisCostaPeretti.05dce11b.pdf";